<template>
  <div class="card">
    <div class="bg-blue-light p-1">
      <TitleButton
          :showBtn="false"
          title="Employee Offboarding Approval"
          :showAddNew="false"
      />
    </div>
    <div class="my-2 px-2">
      <DateQuerySetter
          btnTitle="Go"
          @onClickGo="onClickToGo"
          class="tds-vds-query-setter"
      >
        <div class="col-12 col-sm-6 col-md-4 col-lg-3">
          <label for="colFormLabel" class="col-form-label">Employee</label>
          <AsyncSelect
              placeholder="Employee"
              v-model="contactProfile"
              :api-service="fetchContactProfiles"
              :additional-query="{roles: 'employee'}"
              label="name"
          />
        </div>
      </DateQuerySetter>
    </div>

    <div class="col-12 px-2 mt-2 mb-4">
      <ListTable
          :tableItems="tableItems"
          :getOffBoardingList="getOffBoardingList"
      />
    </div>

    <Loader v-if="loading"/>
  </div>

</template>

<script setup>
import TitleButton from '@/components/atom/TitleButton';
import { inject, ref } from 'vue';
import { useStore } from 'vuex';
import { useRoute, useRouter } from 'vue-router';
import Loader from '@/components/atom/LoaderComponent'
import ListTable from '@/components/molecule/company/hrm-payroll/employee-off-boarding/EmployeeOffBoardingApprovalListTable.vue';
import DateQuerySetter from '@/components/atom/DateQuerySetter.vue';
import handleHrPayroll from "@/services/modules/hrPayroll/hrPayroll";
import { computed } from 'vue';
import handleContact from '@/services/modules/contact'
import AsyncSelect from "@/components/molecule/input-field/AsyncSelect.vue";

const store = useStore();
const route = useRoute();
const router = useRouter();
const showError = inject('showError');
const showSuccess = inject('showSuccess');
const loading = ref(false)
const contactProfileId = ref('');
let contacts = ref([])
const tableItems = ref([]);
const params = ref({
  offset: 30,
});
const contactProfile = ref('');
const token = computed(() => localStorage.getItem('token'));

const {
  fetchEmployeeOffBoardingApprovalData,
} = handleHrPayroll()
const { fetchContactProfiles } = handleContact()

const onClickToGo = () => {
  getOffBoardingList();
}

const getOffBoardingList = async () => {
  const query = getQuery();
  loading.value = true
  tableItems.value = []

  await fetchEmployeeOffBoardingApprovalData(query).then(res => {
    if (!res.status){
      return
    }

    tableItems.value = res.data;
  }).catch(err => {
    console.log(err)
  }).finally(() => {
    loading.value = false
  })
}

const getQuery = () => {
  let query = `?company_id=${route.params.companyId}`;
  if (route.query.page) query += '&page=' + route.query.page;
  if (route.query.start) query += '&start_date=' + route.query.start;
  if (route.query.end) query += '&end_date=' + route.query.end;
  if (contactProfile.value) query += `&contact_profile_id=${contactProfile.value.id}`;
  query += '&offset=' + params.value.offset
  return query;
}

</script>
